import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from 'reactstrap';
import './index.css';
import { getAgeingReportApi, getCommitment, getCreditOutstandingBalanceApi, getStateDistrictCity } from '../../../constants/apiCalls';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import CreditLimit from '../../../Components/CreditLimit';
import PrimaryContact from '../../../Components/PrimaryContact';
import CropAcreage from '../../../Components/CropAcreage';
import Commitment from '../../../Components/Commitment';
import Competition from '../../../Components/Competition';
import DealerSignStamp from '../../../Components/DealerSignStamp/DealerSignStamp';
import OtherOwners from '../../../Components/OtherOwners/OtherOwners';
import ActiveOwner from '../../../Components/ActiveOwner/ActiveOwner';
import AdvanceBusinessInfo from '../../../Components/AdvanceBusinessInfo/AdvanceBusinessInfo';
import BasicBusinessInformation from '../../../Components/BasicBusinessInformation/BasicBusinessInformation';
import ConfirmNote from '../../../Components/ConfirmNote/ConfirmNote';
import PrintableHeader from '../../../Components/PrintableHeader/PrintableHeader';
import { Terms } from '../../../Components/Terms/Terms';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import { CommonButton } from '../../../Components/CommonComponents';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const PreviewApplication = () => {
  const [previewData, setPreviewData] = useState('');
  const [isMultipleUser, setIsMultipleUser] = useState(false);
  const [activeOwner, setActiveOwner] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [selectedOwnerState, setSelectedOwnerState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedOwnerDistrict, setSelectedOwnerDistrict] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedOwnerCity, setSelectedOwnerCity] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isShowDocuments, setIsShowDocuments] = useState(false);
  const [isShowCommitment, setIsShowCommitment] = useState(false);
  const [isShowEntireApp, setIsShowEntireApp] = useState(true);
  const [commitments, setCommitments] = useState('');
  const [isShowCompetition, setIsShowCompetition] = useState(false);
  const [creditOutstandingBalance, setCreditOutstandingBalance] = useState('');
  const [ageingData, setAgeingData] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    setTimeout(() => {
      if (isPrinting) {
        window.print();
        setIsPrinting(!isPrinting);
      }
    }, 100);
  }, [isPrinting]);

  useEffect(() => {
    if (userId) {
      getCommitments(userId);
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    setPreviewData(dealerObj);
    let filterActiveOwner = dealerObj && dealerObj.owners && dealerObj.owners.length > 0 ? dealerObj.owners.filter(val => val.is_primary_contact === true) : [];
    setActiveOwner(filterActiveOwner);
    getStatesData(
      dealerObj.pincode,
      dealerObj.state_id,
      dealerObj.district_id,
      dealerObj.city_id
    );
    if (dealerObj && dealerObj.owners && dealerObj.owners.length > 0) {
      getOwnerState(
        dealerObj.owners[0].pincode,
        dealerObj.owners[0].state_id,
        dealerObj.owners[0].district_id,
        dealerObj.owners[0].city_id
      );
    }
    if(dealerObj && dealerObj.dealer_code){
      getCreditOutstandingBalance();
      getAgeingReportData();
    }
  }, [dealerObj])

  const getCommitments = (id) => {
    if (id) {
      let payload = { user_id: id, page: 1, pagesize: 50, year: '' };
      getCommitment((res) => {
        const { success, data, error } = res;
        if (success === true) {
          for (let i = 0; i < data.length; i++) {
            setCommitments(data);
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
    }
  };

  const getCreditOutstandingBalance = () => {
      let payload = { customer: dealerObj.dealer_code};
      getCreditOutstandingBalanceApi((res) => {
        const { success, data, error } = res;
        if (success === true) {
          const resData = data && data.length > 0 ? data[0] : '';
          setCreditOutstandingBalance(resData);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, payload);
  };

  const getAgeingReportData = () => {
    let payload = { customer: dealerObj.dealer_code };
    getAgeingReportApi((res) => {
      const { success, data, error } = res;
      if (success === true) {
        const resData = data && data.length > 0 ? data[0] : '';
        setAgeingData(resData);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const getStatesData = (pincode, editStateId, editDistrictId, cityId) => {
    if (pincode) {
      let payload = {
        pincode: pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if (success === true) {
          if (data.length > 0) {
            let allData = data;

            // state array
            let stateArr = [
              ...new Map(allData.map((m) => [m.state_id, m])).values(),
            ]; // remove duplicate state
            setSelectedState(stateArr);

            // District array
            let districtArr = [
              ...new Map(allData.map((m) => [m.district_id, m])).values(),
            ]; // remove duplicate district

            let filterDistrict = districtArr.filter(
              (elem) => elem.district_id === editDistrictId
            );

            setSelectedDistrict(filterDistrict);

            // city Arr
            let cityArr = [
              ...new Map(allData.map((m) => [m.city_id, m])).values(),
            ]; // remove duplicate City
            let filterCity = cityArr.filter((elem) => elem.city_id === cityId);
            setSelectedCity(filterCity);

            setIsloading(false);
          }
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
  };

  // owner info
  const getOwnerState = (pincode, stateId, districtId, cityId) => {
    if (pincode) {
      let payload = {
        pincode: pincode,
      };
      getStateDistrictCity((res) => {
        const { success, data, error } = res;
        if (success === true) {
          if (data.length > 0) {
            let allData = data;
            // state array
            let stateArr = [
              ...new Map(allData.map((m) => [m.state_id, m])).values(),
            ]; // remove duplicate state
            setSelectedOwnerState(stateArr);

            // District array
            let districtArr = [
              ...new Map(allData.map((m) => [m.district_id, m])).values(),
            ]; // remove duplicate district
            let filterDistrict = districtArr.filter(
              (elem) => elem.district_id === districtId
            );
            setSelectedOwnerDistrict(filterDistrict);

            // city Arr
            let cityArr = [
              ...new Map(allData.map((m) => [m.city_id, m])).values(),
            ]; // remove duplicate City
            let filterCity = cityArr.filter((elem) => elem.city_id === cityId);
            setSelectedOwnerCity(filterCity);

            setIsloading(false);
          }
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
  };

  const handleOwner = () => {
    setIsMultipleUser(!isMultipleUser);
  };

  const handleBack = () => {
    navigate(`/pages/new-dealer/${userId}`);
  };

  const handleDocuments = (e) => {
    setIsShowDocuments(!isShowDocuments);
    if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleCommitment = (e) => {
    setIsShowCommitment(!isShowCommitment);
    if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleCompetition = (e) => {
    setIsShowCompetition(!isShowCompetition);
    if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowEntireApp) {
      setIsShowEntireApp(!isShowEntireApp);
    }
  };

  const handleEnteireApp = (e) => {
    setIsShowEntireApp(!isShowEntireApp);
    if (isShowCommitment) {
      setIsShowCommitment(!isShowCommitment);
    } else if (isShowDocuments) {
      setIsShowDocuments(!isShowDocuments);
    } else if (isShowCompetition) {
      setIsShowCompetition(!isShowCompetition);
    }
  };

  const printNow = () => {
    setIsPrinting(true);
  };

  const handleOrderHistory = () => {
    navigate(`/order/order-summary/mtd/${userId}`);
  };

  const handleMeetingHistory = () => {
    // navigate(`/meeting/meeting-history/ftd/${userId}`);
    navigate(`/meeting/meeting-history/mtd/${userId}`);
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='PreviewApplication'>
              {isLoading && <CustomSpinner />}
              <Container fluid>
                {isPrinting && (
                  <>
                    <PrintableHeader /> <hr />
                  </>
                )}
                <Row className='noprint align-items-center button-row-wrap'>
                  <Col xs={12}>
                    <div className='topHeader d-flex flex-wrap align-items-center justify-content-lg-between'>
                      <Breadcrumbs title='Preview Application' />
                      <div className='d-flex flex-wrap align-items-center justify-content-end flex-grow-1'>
                        <CommonButton name={'Back'} btnClass={'btnTernary'} type="button" onClick={() => navigate(`/pages/new-dealer/${userId}`)} />
                        {previewData.is_verified === false ||
                          previewData.is_verified === null ? (
                          <CommonButton
                            name={'Verification'}
                            btnClass={'btnPrimary'}
                            disabled={!(userId && (previewData.page_1 === 1 &&
                              previewData.page_2 === 1 &&
                              previewData.page_3 === 1 &&
                              previewData.page_4 === 1 &&
                              previewData.page_5 === 1 &&
                              previewData.page_6 === 1 &&
                              previewData.page_7 === 1 &&
                              previewData.page_8 === 1))}
                            // maxWidth='180px'
                            type="button"
                            onClick={() =>
                              userId &&
                                previewData.page_1 === 1 &&
                                previewData.page_2 === 1 &&
                                previewData.page_3 === 1 &&
                                previewData.page_4 === 1 &&
                                previewData.page_5 === 1 &&
                                previewData.page_6 === 1 &&
                                previewData.page_7 === 1 &&
                                previewData.page_8 === 1
                                ? navigate(`/pages/verify-n-submit/${userId}`)
                                : undefined
                            }
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
                <CreditLimit
                  isPrinting={isPrinting}
                  handleDocuments={handleDocuments}
                  handleCommitment={handleCommitment}
                  handleEnteireApp={handleEnteireApp}
                  handleCompetition={handleCompetition}
                  previewData={previewData}
                  userId={userId}
                  isShowCommitment={isShowCommitment}
                  isShowEntireApp={isShowEntireApp}
                  isShowDocuments={isShowDocuments}
                  isShowCompetition={isShowCompetition}
                  showButtons={true}
                  handleOrderHistory={handleOrderHistory}
                  handleMeetingHistory={handleMeetingHistory}
                  creditOutstandingBalance={creditOutstandingBalance}
                  ageingData={ageingData}
                />
                {isShowEntireApp && (
                  <div>
                    {isPrinting && <hr />}
                    <div id='businessInfoBlock'>
                      <BasicBusinessInformation
                        previewData={previewData}
                        activeOwner={activeOwner}
                        selectedCity={selectedCity}
                        selectedDistrict={selectedDistrict}
                        selectedState={selectedState}
                        userId={userId}
                      />
                    </div>
                    {isPrinting && <hr />}
                    {/* crop acreages */}
                    <div id='cropAcreageBlock'>
                      <CropAcreage previewData={previewData} userId={userId} />
                    </div>
                    {isPrinting && <hr />}
                    {/* advance business information */}
                    <div id='advanceInfoBlock'>
                      <AdvanceBusinessInfo previewData={previewData} userId={userId} />
                    </div>
                    {isPrinting && <hr />}
                    <div id='commitmentBlock'>
                      <Commitment
                        previewData={commitments}
                        previewAllData={previewData}
                        userId={userId}
                      />
                    </div>
                    {isPrinting && <hr />}
                    {/* Businesss Insights */}
                    {isShowEntireApp && (
                      <div id='bInsightBlock'>
                        <Competition previewData={previewData} userId={userId} />
                      </div>
                    )}
                    {isPrinting && <hr />}
                    {/* Owners Information */}
                    <div id='ownerBlock'>
                      <ActiveOwner
                        activeOwner={activeOwner}
                        previewData={previewData}
                        isMultipleUser={isMultipleUser}
                        selectedOwnerCity={selectedOwnerCity}
                        selectedOwnerDistrict={selectedOwnerDistrict}
                        selectedOwnerState={selectedOwnerState}
                        handleOwner={handleOwner}
                        userId={userId}
                      />
                      <OtherOwners
                        previewData={previewData}
                        activeOwner={activeOwner}
                        isMultipleUser={isMultipleUser}
                        selectedOwnerCity={selectedOwnerCity}
                        selectedOwnerDistrict={selectedOwnerDistrict}
                        selectedOwnerState={selectedOwnerState}
                        handleOwner={handleOwner}
                        userId={userId}
                      />
                    </div>
                    {isPrinting && <hr />}
                    <ConfirmNote
                      isShowTmConfirmationNote={false}
                      previewData={previewData}
                    />
                    {isPrinting && <hr />}
                    {/* Primary Contact Information */}
                    <div id='prContactBlock'>
                      <PrimaryContact previewData={previewData} userId={userId} />
                    </div>
                  </div>
                )}
                {isShowCommitment && (
                  <div id='commitmentBlock'>
                    <Commitment
                      previewData={commitments}
                      previewAllData={previewData}
                      userId={userId}
                    />
                  </div>
                )}
                {isShowCompetition && (
                  <div id='bInsightBlock'>
                    <Competition previewData={previewData} userId={userId} />
                  </div>
                )}
                {isShowDocuments && (
                  <div id='advanceInfoBlock'>
                    <AdvanceBusinessInfo previewData={previewData} userId={userId} />
                  </div>
                )}
                {isPrinting && previewData.is_approved === true && <Terms />}
                {isPrinting && <hr />}
                <DealerSignStamp
                  handleBack={handleBack}
                  printNow={printNow}
                  isShowEntireApp={isShowEntireApp}
                  isPrinting={isPrinting}
                  previewData={previewData}
                  userId={userId}
                />
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewApplication;
